import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { API_PATH } from '../../../util/constants';
import { Observable } from 'rxjs';
import { AlterarSenha } from './shared/alterarSenha';

@Injectable()
export class AlterarSenhaService {

  private headers: Headers;
  private opcoes;
  private url;

  constructor(private http: Http) {
    this.headers = new Headers({
      "Allow-Control-Allow-Origin": "*",
      "Allow-Control-Allow-Methods": "GET, POST, PUT, DELETE",
      "Content-Type": "application/json"
    });
    this.opcoes = {headers: this.headers}
  }

  alterarSenha(data: AlterarSenha): Observable<any> {
    return this.http.post(`${API_PATH}/alterar-senha`, data, this.opcoes)
    .map(res=>res.json())
    .catch(err=> Observable.throw(err.message));
  }

}



// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/alterar-senha/alterar-senha.service.ts